import { Typography } from 'ui';

export const Value = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body2" fontWeight={400}>
    {children}
  </Typography>
);
